import { CommonModule } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { IonIcon } from '@ionic/angular';
import { TranslatePipe } from '@ngx-translate/core';

export type InsightCardTone =
  | 'default'
  | 'neutral'
  | 'success'
  | 'warning'
  | 'danger'
  | 'blue'
  | 'green'
  | 'yellow'
  | 'red'
  | 'grey'
  | 'purple'
  | 'orange';

export interface InsightCardItem {
  key: string;
  titleKey: string;
  value: string | number;
  descriptionKey?: string;
  descriptionParams?: Record<string, unknown>;
  helperKey?: string;
  helperParams?: Record<string, unknown>;
  tone?: InsightCardTone;
  icon?: string;
  clickable?: boolean;
}

@Component({
  selector: 'app-insight-cards',
  templateUrl: './insight-cards.component.html',
  styleUrl: './insight-cards.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    CommonModule,
    IonIcon,
    TranslatePipe,
  ],
})
export class InsightCardsComponent {
  items = input<InsightCardItem[]>([]);
  cardClick = output<InsightCardItem>();

  onCardClick(item: InsightCardItem) {
    if (!item.clickable) {
      return;
    }
    this.cardClick.emit(item);
  }
}
